import PropTypes from 'prop-types';
import React from 'react';
import PhaseType from 'types/phase';
import TaskType from 'types/task';
import { connect } from 'react-redux';
import MaterialsOrderedModal from '../materialsOrderedModal';
import { updatePhaseTask } from 'actionCreators/phase';
import PhaseTask from './phase_task';

export class MaterialsOrdered extends PhaseTask {

  onClick = () => {
    if (this.props.task.status === 'complete') this.toggleStatus();
    else this.setState({ modalActive: true });
  }

  renderChildren = () => {
    const { phase, task, user: { name, role } } = this.props;
    return (<MaterialsOrderedModal
      phase={phase}
      userName={name}
      role={role}
      task={task}
      active={this.state.modalActive}
      completeTask={this.completeTask}
      onClose={this.handleClose}
    />);
  }
}

MaterialsOrdered.propTypes = {
  phase: PhaseType.isRequired,
  task: TaskType.isRequired,
  updatePhaseTask: PropTypes.func.isRequired,
};

export const workorder_materials_ordered = connect(
  () => state => ({ user: state.user }), { updatePhaseTask },
)(MaterialsOrdered);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/materials_ordered.jsx